// extracted by mini-css-extract-plugin
export default {"header":"TermsAndPolicyLayout_header__-w4tj","main":"TermsAndPolicyLayout_main__-YocH"};